import { SET_CUSTOMER_SERVICE_CONTENT } from "actions/types";

let initialState = {
  customerServiceContent: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_CUSTOMER_SERVICE_CONTENT: {
      return {
        ...state,
        customerServiceContent: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
